import { Locale, extendLocale } from '@antv/s2';

extendLocale(Locale);
